/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import HeaderListado from "./headerListado"

const LayoutListado = ({ children }) => {

  return (
    <>
      <HeaderListado />
      <main>{children}</main>
    </>
  )
}

LayoutListado.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LayoutListado
